import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const pacienteGuard = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const user = authService.currentUser();
  
  console.log('[PacienteGuard] Verificando acesso:', user);
  
  if (!user) {
    // Não autenticado, redirecionar para login
    console.log('[PacienteGuard] Usuário não autenticado, redirecionando para /login');
    router.navigate(['/login']);
    return false;
  }

  if (user.tipo === 'cliente' || user.tipo === 'paciente') {
    // É paciente/paciente, pode acessar
    console.log('[PacienteGuard] Usuário é paciente, acesso permitido');
    return true;
  }

  // Redirecionar para o dashboard apropriado
  if (user.tipo === 'farmacia') {
    console.log('[PacienteGuard] Usuário é farmácia, redirecionando para /farmacia/dashboard');
    router.navigate(['/farmacia/dashboard']);
  } else if (user.tipo === 'clinica') {
    console.log('[PacienteGuard] Usuário é clínica, redirecionando para /clinica/dashboard');
    router.navigate(['/clinica/dashboard']);
  } else if (user.tipo === 'deposito') {
    console.log('[PacienteGuard] Usuário é depósito, redirecionando para /deposito/dashboard');
    router.navigate(['/deposito/dashboard']);
  } else if (user.tipo === 'profissional_saude') {
    console.log('[PacienteGuard] Usuário é profissional, redirecionando para /profissional/dashboard');
    router.navigate(['/profissional/dashboard']);
  } else if (user.tipo === 'admin') {
    console.log('[PacienteGuard] Usuário é admin, redirecionando para /admin/dashboard');
    router.navigate(['/admin/dashboard']);
  } else {
    console.log('[PacienteGuard] Tipo de usuário desconhecido, redirecionando para /login');
    router.navigate(['/login']);
  }
  
  return false;
};
